
import Vue from 'vue';
import Component from 'vue-class-component';
import { State } from 'vuex-class';

@Component
export default class Contact extends Vue {

  /* VUEX */

  // STATE
  @State('employer', { namespace: 'employer' }) private employer: any;

  /* INITIALIZATION */

  constructor() {
    super();
  }
}
